//fix radio button not being clickable
document.addEventListener('crStorePickupInit', function (e) {
  setTimeout(function(){
    //console.log('buttons loaded', jqCR('.cr-radio'))
    jqCR('.cr-radio').on('click', function(e){      
      e.stopPropagation();
      var currentValue = '#' + jqCR(this).val();
      console.log(currentValue)
      jqCR(currentValue).click()
      
      setTimeout(function(){jqCR(currentValue).click()}, 50)
  
    })    
  }, 500)
  
})

document.addEventListener('crPickupActivated', function (e) {
  const length = jqCR('#pickup-store-search').length
  if (!length) {
    jqCR('#store-search').prepend('<input type="text" name="pickup-store-search" id="pickup-store-search" onkeyup="storePickup.storeFilter()" placeholder="Search..." class="valid" aria-invalid="false">')            
  }
	

})